export function Blur({ children }: Readonly<{ children: React.ReactNode }>) {
    return (
        <div style={{ filter: 'blur(5px)' }}>
            {children}
        </div>
    );
}
